import { render, staticRenderFns } from "./ImportShape.vue?vue&type=template&id=3f12e702"
import script from "./ImportShape.vue?vue&type=script&lang=js"
export * from "./ImportShape.vue?vue&type=script&lang=js"
import style0 from "./ImportShape.vue?vue&type=style&index=0&id=3f12e702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports